import React from "react";
import "./style.css";

// 1-20: "You can do it better !"
// 20-50: "You are progressing need little focus !"
// 50-80: "Good job! Keep it up."
// 80-100: "You are excellent !"

const SpeechBubble = ({ value }) => {
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    if (value > 0 && value <= 20) {
      setMessage("You can do it better !");
    } else if (value > 20 && value <= 50) {
      setMessage("You are progressing need little focus !");
    } else if (value > 50 && value <= 80) {
      setMessage("Good job! Keep it up.");
    } else {
      setMessage("You are excellent !");
    }
  }, [value]);

  return (
    <div className="talk-bubble tri-right btm-right">
      <div className="talktext">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default SpeechBubble;
